var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { property } from 'lit/decorators.js';
/**
 * Clever Cloud fork
 * https://github.com/CleverCloud/clever-components/blob/master/src/mixins/with-resize-observer.js
 * @param ParentClass
 * @returns ResizableLitElement
 */
export const withResizeObserver = (ParentClass) => {
    class ClassWithResizeObserver extends ParentClass {
        _onResize({ width }) {
            if (this.onResize != null) {
                this.onResize({ width });
            }
            if (this.breakpoints != null) {
                this.breakpoints.width.forEach(breakpoint => {
                    const gteAttr = 'w-gte-' + breakpoint;
                    breakpoint <= width
                        ? this.setAttribute(gteAttr, '')
                        : this.removeAttribute(gteAttr);
                    const ltAttr = 'w-lt-' + breakpoint;
                    width < breakpoint
                        ? this.setAttribute(ltAttr, '')
                        : this.removeAttribute(ltAttr);
                });
            }
        }
        connectedCallback() {
            if (super.connectedCallback != null) {
                super.connectedCallback();
            }
            if (window.ResizeObserver == null) {
                return;
            }
            const ro = new window.ResizeObserver(() => {
                // NOTE: We could use entries[0].borderBoxSize.inlineSize but not supported in Chrome, Safari or polyfill
                const { width } = this.getBoundingClientRect();
                this._onResize({ width });
            });
            ro.observe(this);
            this._unobserveResize = () => ro.unobserve(this);
        }
        disconnectedCallback() {
            if (super.connectedCallback != null) {
                super.disconnectedCallback();
            }
            if (this._unobserveResize) {
                this._unobserveResize();
            }
        }
    }
    __decorate([
        property({ type: Number, attribute: false })
    ], ClassWithResizeObserver.prototype, "_width", void 0);
    return ClassWithResizeObserver;
};
//# sourceMappingURL=with-resize-observer.js.map